import { Card, CardBody, Col } from "reactstrap";
import DataTable from "react-data-table-component";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { HtmlTableTittle } from "../../../../Constant";
import { HTML_COLUMN, HTML_COLUMN_DATA, HTML_DATA } from "../../../../Data/DataTable/DataSourceData";

const HtmlSourcedData = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={HtmlTableTittle} span={HTML_DATA} />
        <CardBody>
          <div className="table-responsive">
            <DataTable data={HTML_COLUMN_DATA} columns={HTML_COLUMN} striped highlightOnHover pagination />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default HtmlSourcedData;
